import PageLayout from "layout/constants/pageLayoutNames";
import ResultPresentationType from "layout/constants/resultPresentationType";

const lookup = {
    [PageLayout.Communities]: ResultPresentationType.Pagination.toString(),
    [PageLayout.Homes]: ResultPresentationType.Pagination.toString(),
    [PageLayout.Builders]: ResultPresentationType.InfiniteScrolling.toString(),
    [PageLayout.BoylLocations]: ResultPresentationType.Pagination.toString(),
    [PageLayout.CustomHomes]: ResultPresentationType.Pagination.toString(),
    [PageLayout.ManufacturedLocations]: ResultPresentationType.Pagination.toString(),
    [PageLayout.ManufacturedHomes]: ResultPresentationType.Pagination.toString(),
};

const getResultPresentationByLayoutName = (layoutName) => lookup[layoutName];

export default getResultPresentationByLayoutName;